<template>
  <div>
    <span v-if="debug === 'true' || debug === true">{{version}}</span>
    <b-container class="mt-4 mb-4">
      <label>Código postal:</label>
      <b-form-input
        maxlength="5"
        v-model="codigoBuscar"
        placeholder="Buscar código postal"
        :state="codigoBuscar.length == 5"
      ></b-form-input>
    </b-container>

    <b-button variant="outline-primary" v-if="!enviando" v-on:click="buscarCp"
      >Buscar</b-button
    >
    <b-button variant="primary" v-show="enviando" disabled>
      <b-spinner small></b-spinner>
      Cargando...
    </b-button>

    <div class="mt-4" v-if="mostrarCodigos">
      <b-table
        thead-tr-class="subtitulos"
        responsive
        striped
        hover
        :items="listaCodigos"
        :fields="fields"
        v-if="listaCodigos.length != 0"
      >
        <template v-slot:cell(Acciones)="row">
          <b-button-group>
            <b-button
                title="Modificar codigo postal"
                size="sm"
                @click="modificar(row.item)"
                variant="outline-warning"
                v-if="$localStorageService.can('Cod_postal_editar')"
            >
              <em class="fa fa-pencil"></em>
            </b-button>
            <b-button
                v-if="!row.item.registroActivo && $localStorageService.can('Cod_postal_activar')"
                title="Activar codigo postal"
                size="sm"
                @click="activar(row.item)"
                variant="outline-danger"
            >
              <em class="fa fa-undo"></em>
            </b-button>
            <b-button
                v-else-if="$localStorageService.can('Cod_postal_activar')"
                title="Desactivar codigo postal"
                size="sm"
                @click="desactivar(row.item)"
                variant="outline-danger"
            >
              <b-icon icon="trash-fill"></b-icon>
            </b-button>
          </b-button-group>
        </template>
      </b-table>
      <h2 v-else>El código postal ingresado no existe.</h2>
    </div>

    <b-modal
        v-model="mostrarModal"
        :title="tituloModal"
        size="lg"
        scrollable
    >
      <b-form @submit.stop.prevent="guardar">
        <b-container fluid>
          <b-row>
            <b-col>
              <b-form-group align="left">
                <label for="postal">Codigo postal <validacion/> </label>
                <b-input-group size="sm" class="mb-2" id="postal">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      name="postal"
                      placeholder="Codigo postal"
                      v-model="codigoPostal.codigoPostal"
                      :state="codigoPostal.codigoPostal != '' && codigoPostal.codigoPostal != null && codigoPostal.codigoPostal.length == 5"
                      required
                  >
                  </b-form-input>
                </b-input-group>
                <label for="localidad">Colonia <validacion/> </label>
                <b-input-group size="sm" class="mb-2" id="localidad">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-input
                      name="localidad"
                      placeholder="Colonia: "
                      v-model="codigoPostal.nombreLocalidad"
                      :state="codigoPostal.nombreLocalidad != '' && codigoPostal.nombreLocalidad != null"
                      required
                  >
                  </b-form-input>
                </b-input-group>
                <label for="estado">Estado <validacion/> </label>
                <b-input-group size="sm" class="mb-2" id="estado">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-select
                      name="estado"
                      v-model="codigoPostal.idEstado"
                      :options="listaEstados"
                      v-on:change="buscarColonias"
                      value-field="idEstado"
                      text-field="nombreEstado"
                      :state="codigoPostal.idEstado != null"
                      required
                  >
                  </b-form-select>
                </b-input-group>
                <label for="municipio">Municipio <validacion/> </label>
                <b-input-group size="sm" class="mb-2" id="municipio">
                  <b-input-group-prepend is-text>
                    <b-icon icon="menu-button-wide"></b-icon>
                  </b-input-group-prepend>
                  <b-form-select
                      name="municipio"
                      v-model="codigoPostal.idMunicipio"
                      :options="listaLocalidades"
                      value-field="idMunicipio"
                      text-field="nombreMunicipio"
                      :state="codigoPostal.idMunicipio != null"
                      required
                  >
                  </b-form-select>
                </b-input-group>
              </b-form-group>
            </b-col>
          </b-row>
        </b-container>
        <b-button ref="submitGuardar" type="submit" style="visibility: hidden"></b-button>
      </b-form>

      <template v-slot:modal-footer>
        <b-button variant="outline-primary" type="submit" @click="submitGuardar" :disabled="loaderAcciones">
          <span v-if="!loaderAcciones">Guardar</span>
          <span v-if="loaderAcciones">
            <b-spinner small></b-spinner>
            Cargando...
          </span>
        </b-button>
        <b-button variant="outline-danger" :disabled="loaderAcciones" @click="cerrarModal">Cancelar</b-button>
      </template>
    </b-modal>
  </div>
</template>

<script>
import VueNotifications from "vue-notifications";

export default {
  name: "BuscarCp",
  data: () => ({
    version: process.env.VUE_APP_ENV_VERSION,
    debug: false,
    codigoBuscar: "",
    listaCodigos: [],
    fields: [
      {
        key: "nombreEstado",
        label: "Estado",
      },
      {
        key: "nombreMunicipio",
        label: "Municipio",
      },
      {
        key: "codigoPostal",
        label: "Código",
      },
      {
        key: "nombreLocalidad",
        label: "Colonia",
        sortable: true,
      },
      "Acciones"
    ],
    mostrarCodigos: false,
    enviando: false,
    loaderAcciones: false,
    codigoPostal: {
      idLocalidad: null,
      nombreLocalidad: null,
      idMunicipio: null,
      idEstado: null,
      codigoPostal: null
    },
    mostrarModal: false,
    tituloModal: null,
    listaEstados: [],
    listaLocalidades: []
  }),
  created() {
    //traemos los estados
    this.buscarEstados();
    this.debug = this.$localStorageService.getDebug();
  },
  methods: {
    buscarCp() {
      if (
        this.codigoBuscar.length == 5 &&
        this.codigoBuscar !== "" &&
        !isNaN(this.codigoBuscar)
      ) {
        this.enviando = true;

        const params = {
        codigoPostal: this.codigoBuscar
      }
        //buscamos las colonias del codigo postal
        const urlLocalidadesCp =
          this.$api + "localidad/postales";

        this.$http
          .post(urlLocalidadesCp, params)
          .then((response) => {
            if (response.data.data) {
              this.mostrarCodigos = true;
              this.listaCodigos = response.data.data;
              this.enviando = false;
            }
          })
          .catch((err) => {
            this.showErrorMsg(err);
            this.enviando = false;
          });
      } else {
        this.$swal({
          icon: "error",
          text: "Debe colocar 5 dígitos para el código postal",
        });
      }
    },
    buscarEstados() {
      let supper = this;
      const urlEstados = this.$api + "catalogos/listaEstados";
      this.$http
          .get(urlEstados)
          .then(function (response) {
            if (response.data.data) {
              let tituloEstado = {
                idEstado: null,
                nombreEstado: "Estado: ",
              };
              response.data.data.unshift(tituloEstado);
              supper.listaEstados = response.data.data;
            }
          })
          .catch(function (err) {
            supper.showErrorMsg(err);
          });
    },
    buscarColonias() {
      if (this.codigoPostal.idEstado != null) {
        let supper = this;
        const urlMunicipios =
            this.$api +
            "catalogos/listaMunicipios?idEstado=" +
            this.codigoPostal.idEstado;
        this.$http
            .get(urlMunicipios)
            .then(function (response) {
              if (response.data.data) {
                let tituloMunicipio = {
                  idMunicipio: null,
                  nombreMunicipio: "Municipio: ",
                };
                response.data.data.unshift(tituloMunicipio);
                supper.listaLocalidades = response.data.data;
              }
            })
            .catch(function (err) {
              supper.showErrorMsg(err);
            });
      }
    },
    guardar() {
      this.loaderAcciones = true;
      this.$http.post(this.$api + 'localidad/cpModificar', this.codigoPostal).then(respuesta => {
        if(respuesta.data.success) {
          this.$swal.fire({
            icon: "info",
            title: "Aviso",
            text: respuesta.data.message
          });
          if (respuesta.data.data != null){
            this.codigoBuscar = this.codigoPostal.codigoPostal;
            this.buscarCp();
            this.mostrarModal = false;
          }
        }
      }).catch(error => {
        console.error(error);
        this.$swal.fire({
          icon: "error",
          title: "Aviso",
          text: "Hubo un problema al guardar."
        });
      }).finally(() => {
        this.loaderAcciones = false;
      })
    },
    modificar(item) {
      this.codigoPostal = JSON.parse(JSON.stringify(item));
      this.tituloModal = 'Modificar codigo postal';
      this.mostrarModal = true;
      this.buscarColonias();
    },
    activar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de activar el codigo postal?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http.delete(this.$api + 'localidad/activarDesactivar?idLocalidad=' + item.idLocalidad).then(respuesta => {
            if (respuesta.data.data) {
              this.listaCodigos[this.listaCodigos.indexOf(item)].registroActivo = true;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El codigo postal se activó correctamente."
              });
            }
          }).catch(error => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Hubo un problema al activar.",
            });
          })
        }
      })
    },
    desactivar(item) {
      this.$swal({
        icon: "warning",
        text: "¿Está seguro de desactivar el codigo postal?",
        confirmButtonText: 'Si',
        cancelButtonText: 'No',
        showCancelButton: true,
        showConfirmButton: true,
      }).then((aceptar) => {
        if (aceptar.value) {
          this.$http.delete(this.$api + 'localidad/activarDesactivar?idLocalidad=' + item.idLocalidad).then(respuesta => {
            if (respuesta.data.data) {
              this.listaCodigos[this.listaCodigos.indexOf(item)].registroActivo = false;
              this.$swal.fire({
                icon: "info",
                title: "Aviso",
                text: "El codigo postal se desactivó correctamente."
              });
            }
          }).catch(error => {
            console.error(error);
            this.$swal.fire({
              icon: "error",
              title: "Aviso",
              text: "Hubo un problema al desactivar.",
            });
          })
        }
      })
    },
    submitGuardar() {
      this.$refs.submitGuardar.click();
    },
    cerrarModal() {
      this.mostrarModal = false;
      this.codigoPostal = {
        idLocalidad: null,
        nombreLocalidad: null,
        idMunicipio: null,
        idEstado: null,
        codigoPostal: null
      }
    }
  },
  notifications: {
    showErrorMsg: {
      type: VueNotifications.types.error,
      title: "Error",
      message: "Error al traer la información",
    },
  },
};
</script>